import { BrowserRouter, Route, Routes } from "react-router-dom";

import ListView from "src/components/ListView";
import Login from "src/components/Login";
import MapView from "src/components/MapView";
import CategoryView from "src/components/settings/CategoryView";
import MapsView from "src/components/settings/MapsView";
import UserView from "src/components/settings/UserView";
import SharedLayout from "src/components/SharedLayout";

import { HandleRedirection } from "./handleRedirection";
import {
    URL_CATEGORY_SETTINGS,
    URL_LIST_VIEW,
    URL_LOGIN,
    URL_MAP_SETTINGS,
    URL_MAP_VIEW,
    URL_SCHEMA,
    URL_USER_SETTINGS,
} from "./routes";

export const Router = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path={`${URL_SCHEMA}${URL_LOGIN}`} element={<Login />} />

                <Route element={<SharedLayout />}>
                    <Route
                        path={`${URL_SCHEMA}${URL_MAP_VIEW}`}
                        element={<MapView />}
                    />
                    <Route
                        path={`${URL_SCHEMA}${URL_LIST_VIEW}`}
                        element={<ListView />}
                    />
                    <Route
                        path={`${URL_SCHEMA}${URL_USER_SETTINGS}`}
                        element={<UserView />}
                    />
                    <Route
                        path={`${URL_SCHEMA}${URL_MAP_SETTINGS}`}
                        element={<MapsView />}
                    />

                    <Route
                        path={`${URL_SCHEMA}${URL_CATEGORY_SETTINGS}`}
                        element={<CategoryView />}
                    />
                </Route>

                <Route
                    path={`${URL_SCHEMA}/*`}
                    element={<HandleRedirection />}
                />
            </Routes>
        </BrowserRouter>
    );
};
